// Title Overlay component - HTML text over SVG center
import { i18n } from '../utils/i18n';
import { appState } from '../utils/appState';
import { analytics } from '../utils/analytics';

export class TitleOverlay {
  private container: HTMLElement;
  private aboutButton: HTMLButtonElement | null = null;

  constructor(containerSelector: string) {
    const element = document.querySelector(containerSelector);
    if (!element) throw new Error(`Element "${containerSelector}" not found`);

    this.container = element as HTMLElement;
  }

  init(): void {
    this.render();
    this.setupAboutButton();

    // Update on locale change
    window.addEventListener('localechange', () => {
      this.render();
    });
  }

  private render(): void {
    const title = i18n.getString('ui.title');

    // Find overlay within svg-wrapper
    const svgWrapper = this.container.querySelector('.svg-wrapper');
    if (!svgWrapper) {
      console.error('.svg-wrapper not found');
      return;
    }

    const titleElement = svgWrapper.querySelector('.title-overlay-text');

    if (titleElement) {
      titleElement.textContent = title;
      titleElement.setAttribute('data-i18n-key', 'ui.title');
    } else {
      console.error('.title-overlay-text not found in .svg-wrapper');
    }

    // Update button text
    const buttonText = i18n.getString('ui.aboutButton');
    const buttonTextElement = svgWrapper.querySelector('.title-overlay-button-text');
    if (buttonTextElement) {
      buttonTextElement.textContent = buttonText;
    }
  }

  private setupAboutButton(): void {
    const svgWrapper = this.container.querySelector('.svg-wrapper');
    if (!svgWrapper) return;

    this.aboutButton = svgWrapper.querySelector('.title-overlay-button');

    if (this.aboutButton) {
      this.aboutButton.addEventListener('click', () => {
        analytics.trackSegmentClick('about', 'about');
        appState.activeSegment.set({ type: 'about', key: 'about' });
      });
    }
  }
}
